// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"8be6a846","513":"30351b70","703":"0f3643c3","787":"dd232f96"}[chunkId] + ".chunk.js";
};